'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dStore$002dGroup$002dView$0024$0024anon$00249 from "./presto.-Store-Group-View$$anon$9.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dUser$002dCode$0024 from "./presto.types$-User-Code$.js";
import * as $j_presto$002etypes$0024$002dUser$002dEntry$0024 from "./presto.types$-User-Entry$.js";
import * as $j_presto$002etypes$0024$002dUser$002dId$0024 from "./presto.types$-User-Id$.js";
import * as $j_presto$002etypes$0024$002dUser$002dKind$0024 from "./presto.types$-User-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_StoreGroupView$$anon$8() {
  this.bzs = null;
  this.bzk = null;
  this.bzl = false;
  this.bzt = null;
  this.bzu = false;
  this.bzx = null;
  this.bzq = null;
  this.bzr = false;
  this.bzm = null;
  this.bzn = false;
  this.bzo = null;
  this.bzp = false;
  this.bzv = false;
  this.bzw = false;
  this.bzs = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bzx = "UserEntry";
}
export { $c_Lpresto_StoreGroupView$$anon$8 as $c_Lpresto_StoreGroupView$$anon$8 };
$p = $c_Lpresto_StoreGroupView$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_StoreGroupView$$anon$8;
/** @constructor */
function $h_Lpresto_StoreGroupView$$anon$8() {
}
export { $h_Lpresto_StoreGroupView$$anon$8 as $h_Lpresto_StoreGroupView$$anon$8 };
$h_Lpresto_StoreGroupView$$anon$8.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bzs;
});
$p.M = (function() {
  if ((!this.bzl)) {
    this.bzk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bzl = true;
  }
  return this.bzk;
});
$p.O = (function() {
  if ((!this.bzu)) {
    this.bzt = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bzu = true;
  }
  return this.bzt;
});
$p.E = (function() {
  return this.bzx;
});
$p.t = (function() {
  if ((!this.bzr)) {
    this.bzq = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deleted", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("active", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))));
    this.bzr = true;
  }
  return this.bzq;
});
$p.N = (function() {
  if ((!this.bzn)) {
    this.bzm = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dUser$002dId$0024.$m_Lpresto_types$UserId$().jW(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_presto$002etypes$0024$002dUser$002dKind$0024.$m_Lpresto_types$UserKind$().sB())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dUser$002dCode$0024.$m_Lpresto_types$UserCode$().sA(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().at, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cJ(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))));
    this.bzn = true;
  }
  return this.bzm;
});
$p.Q = (function() {
  if ((!this.bzp)) {
    this.bzo = new $j_presto$002e$002dStore$002dGroup$002dView$0024$0024anon$00249.$c_Lpresto_StoreGroupView$$anon$9();
    this.bzp = true;
  }
  return this.bzo;
});
$p.v = (function() {
  if ((!this.bzw)) {
    this.bzv = false;
    this.bzw = true;
  }
  return this.bzv;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee176) => ((p) => \u03b4scrutinee176.sv(p)))($j_presto$002etypes$0024$002dUser$002dEntry$0024.$m_Lpresto_types$UserEntry$())));
});
var $d_Lpresto_StoreGroupView$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_StoreGroupView$$anon$8, "presto.StoreGroupView$$anon$8", ({
  Sl: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_StoreGroupView$$anon$8 as $d_Lpresto_StoreGroupView$$anon$8 };
//# sourceMappingURL=presto.-Store-Group-View$$anon$8.js.map
